import { Referral } from '../../interface/referralTypes';

export const CREATE_REFERRAL_REQUEST = 'CREATE_REFERRAL_REQUEST';
export const CREATE_REFERRAL_SUCCESS = 'CREATE_REFERRAL_SUCCESS';
export const CREATE_REFERRAL_FAILURE = 'CREATE_REFERRAL_FAILURE';

export interface CreateReferralRequestAction {
    type: typeof CREATE_REFERRAL_REQUEST;
}

export interface CreateReferralSuccessAction {
    type: typeof CREATE_REFERRAL_SUCCESS;
    payload: Referral;
}

export interface CreateReferralFailureAction {
    type: typeof CREATE_REFERRAL_FAILURE;
    payload: string;
}

export type ReferralActionTypes =
    | CreateReferralRequestAction
    | CreateReferralSuccessAction
    | CreateReferralFailureAction;

export interface ReferralState {
    loading: boolean;
    referrals: Referral[];
    totalReferrals: number;
    page: number;
    limit: number;
    totalPages: number;
    error: string | null;
}
